module.exports = __webpack_public_path__ + "static/media/wild-booster.e1caf82b.gif";